export const GET_NOTIFICATION_SUCCESS = 'GET_NOTIFICATION_SUCCESS';
export const GET_NOTIFICATION_ERROR = 'GET_NOTIFICATION_ERROR';
export const LOADING = 'LOADING';
export const NOTIFICATIONS_RESET = 'NOTIFICATIONS_RESET';
